import "./TempMessagePromptComponent.scss";
import template from "./TempMessagePromptComponent.html";
import {IComponentOptions, IOnDestroy} from "angular";
import {Observable, ReplaySubject} from "rxjs";
import {Branding} from "../../../../../types/Branding";
import {CurrentUserService} from "../../../../../services/user/CurrentUserService";

export const TempMessagePrompt = "tfTempMessagePrompt";

export function tempMessagePrompt(): IComponentOptions {
    return {
        template,
        controllerAs: "ctrl",
        controller: TempMessagePromptSystemPromptComponentController
    };
}

export class TempMessagePromptSystemPromptComponentController implements IOnDestroy {

    public readonly accountOpeningPath: Observable<string>;

    private readonly destroy$ = new ReplaySubject<boolean>(1);

    public readonly visible: boolean;
    /** @ngInject */
    public constructor(private readonly currentUserService: CurrentUserService) {
        const isOpenTrader = currentUserService.isBranding(Branding.OPEN_TRADER);

        this.visible = true;
    }

    public $onDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
